import React from "react";
import { Image, Button, Row, Col, Form, Modal } from "react-bootstrap";
import "../../css/_common.css";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Core, Lambda, DDB } from "../../api";
import ContentLoader from "react-content-loader";
import { History_Details_Box } from "./_common";
import Loader from "react-loader-spinner";
import * as dotenv from "dotenv";
dotenv.config();

class Order_History extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			isRefreshing: false,
			orders: [],
			modalVisible: false,
			ts_load: 0,
			data: [],
			lastEvalKey: null
			// orderModal: false,
		};
	}

	/**
	 */
	render() {
		// console.log("data", this.state)

		if (this.state.isLoading) {
			return (
				<div className="centerScreen" style={{ marginTop: 32 }}>
					<Loader type="Bars" color={this.props.__biz.site_settings.base.colors.primary} height={200} width={200} timeout={30000000} />
				</div>
			);
		}

		return (
			<div className="profileBodyDiv">
				<div>
					<div style={{ flexDirection: "row", display: "flex" }}>
						<h3 style={{ flex: 1 }}> Order History</h3>
					</div>
					<div>
						<Row>
							{this.state.data.length === 0 ? (
								<div className="imageText">
									<Image className="orderCompleteImage" style={{ height: 250, width: "auto" }} src={require("../assets/img/placeholder/orderHistory.png")} rounded />
									<div className="alertMessage">No Order History Found</div>
								</div>
							) : (
								this.state.data.map((order, idx) => (
									<History_Details_Box
										key={idx}
										item={order}
										date={
											new Date(order.dt_create * 1000).getDay() +
											"-" +
											parseInt(new Date(order.dt_create * 1000).getMonth() + 1) +
											"-" +
											new Date(order.dt_create * 1000).getFullYear()
										}
									/>
								))
							)}
						</Row>
					</div>
				</div>
			</div>
		);
	}

	LoadData = async b_new => {
		// console.log( 'History: LoadData' );

		try {
			const cfg = this.props.__cfg;

			this.setState({ isLoading: true });

			// the customer's orders for this business, through fnBeta (the old direct read used
			// legacy tables the customer role can't access)
			const aws_lambda = new Lambda({});

			const resp_lambda = await aws_lambda.Invoke(
				{
					stage: cfg.stage,
					usr: "beta",
					actType: "order",
					act: "get:hist_biz",
					bizId: this.props.__biz.biz_id
				},
				cfg.lambda("beta", cfg.stage)
			);

			if (resp_lambda.errorMessage) {
				throw new Error(resp_lambda.errorMessage);
			}

			// placed orders only (not abandoned checkouts), newest first
			const orders_arr = (Array.isArray(resp_lambda) ? resp_lambda : [])
				.filter(x => x.respond && "created" !== x.respond)
				.sort((a, b) => (b.dt_create || 0) - (a.dt_create || 0));

			this.setState({
				isLoading: false,
				ts_load: Date.now(),
				data: orders_arr,
				lastEvalKey: null
			});
		} catch (err) {
			console.warn("History: LoadData: err: ", err);

			this.setState({ isLoading: false, isRefreshing: false });
		}
	}; // LoadData
	/**
	 */
	componentDidMount() {
		// console.log( 'History: componentDidMount' );

		this.LoadData()
			.then(data => {})
			.catch(err => console.error("History: componentDidMount: err: ", err));
	}
}

export default Order_History;
